/*
 * Data card (design/50-components.md "Card"): the default. Border-only, `lg` radius, `xl` inset,
 * and no shadow, because it is not interactive.
 */
.root {
  padding: var(--space__xl);
  border: 1px solid var(--color__gray-300);
  border-radius: var(--border-radius__lg);
  background: var(--color__white);
}

/*
 * Highlighted: the static half of the shadow rule. The same resting step the action card carries
 * and no hover step, because nothing here is pressable, and it keeps this card's own `lg` radius
 * and `xl` inset rather than borrowing the action card's, since the shadow is the only thing meant
 * to differ from its siblings.
 */
.highlighted {
  box-shadow: 0 1px 2px oklch(from var(--color__gray-900) l c h / 0.15);
}
